<template>
  <div class="sub-content" style="display:flex">
    <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="diary-wrap" style="width:33%;margin-right:2%;">
      <dx-data-grid
        ref="refCarPlanGrid"
        :data-source="planInfoListCar"
        :show-borders="true"
        :showRowLines="true"
        :showColumnLines="true"
        :hover-state-enabled="true"
        :allowColumnResizing="true"
        column-resizing-mode="widget"
        :allow-column-reordering="true"
        :height="gridHeight"
        :row-alternation-enabled="false"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="true"
        key-expr="seqId"
        @toolbar-preparing="onToolbarPreparing"
        :focused-row-key="focusedRowKey"
        @row-updated="onRowUpdatedPlan"
        @row-updating="onRowUpdatingPlan"
        @cellPrepared="onCellPreparedPlan"
        @focused-row-changed="onSelectionChanged"
      >
        <DxGrouping :auto-expand-all="true" />
        <DxSearchPanel :visible="true" :width="100" placeholder="검색..." />
        <DxExport :enabled="true" :file-name="selectedMonth" />
        <DxKeyboardNavigation
          :edit-on-key-press="true"
          enter-key-action="moveFocus"
          enter-key-direction="row"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="true"
          :allow-adding="false"
          :use-icons="true"
          mode="cell"
        >
        </DxEditing>
        <DxColumnFixing :enabled="true" />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          data-field="제조사"
          :group-index="0"
        >
        </DxColumn>
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          data-field="차종"
          :group-index="1"
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :fixed="true"
          caption="사양"
          data-field="사양"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :fixed="true"
          caption="점유율"
          data-field="점유율"
          format="#0.##%"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :fixed="true"
          format="#,##0"
          caption="월계획"
          data-field="월계획"
          dataType="number"
        >
        </DxColumn>
        <!-- <DxColumn
          :caption="selectedMonth"
          alignment='center'
        >
          <DxColumn v-for='(item, index)  in  dateArray' :key="index"
            :allowEditing='false'
            :caption = item.caption
            :data-field = item.dataField
            :data-type = item.dataType
            :format = item.format
            :allow-sorting="false"
          />
        </DxColumn> -->
        <DxSummary>
          <DxGroupItem
            column="차종"
            summary-type="count"
            display-format="{0} 건"
          />
        </DxSummary>
        <!-- <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="월계획"
            summary-type="sum"
            display-format="{0}"
          />
          <DxTotalItem v-for='(item, index)  in  dateArray' :key="index+50"
            value-format='#,##0'
            :column = item.dataField
            summary-type="sum"
            display-format="{0}"
          />
        </DxSummary> -->
        <dx-paging :enabled="false" />
        <dx-scrolling
          mode="virtual"
          row-rendering-mode="virtual"
          showScrollbar="always"
          :useNative="false"
        />
        <dx-sorting mode="none" />
      </dx-data-grid>
    </div>
    <div class="goods-plan-wrap" style="width:65%">
      <MonthPlanComponent ref="refMonthPlan" :gridHeight="gridHeight" />
    </div>
    <loading
      :active.sync="isLoading"
      color="rgb(2, 110, 156)"
      loader="bars"
    ></loading>
    <DxPopup
      :show-title="true"
      :width="700"
      :height="450"
      title="일괄등록"
      :visible="false"
    >
      <!-- <dx-position
        my="center"
        at="center"
        of="window"
      /> -->
    </DxPopup>
    <input
      id="batch-month-plan-input"
      type="file"
      @change="confirmRegMonthPlanCar($event)"
      accept=".xlsx"
      style="display: none;"
    />
  </div>
  <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxExport,
  DxColumnFixing,
  DxSummary,
  DxKeyboardNavigation,
  DxGrouping,
  DxGroupItem,
  DxColumn,
  DxPaging,
  DxSorting,
  DxEditing,
  DxSearchPanel
} from 'devextreme-vue/data-grid'
import { DxPopup } from 'devextreme-vue/popup'
import HttpService from '../../share/service/HttpService'
import axios from 'axios'
import MonthPlanComponent from './MonthPlanComponent'
import ExcelJS from 'exceljs'

export default {
  name: 'monthPlan',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: '월생산계획'
        }
      ],
      gridHeight: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      monthDay: null,
      selectedMonth: null,
      dateArray: null,
      planInfoListCar: [],
      updateMode: false,
      thisMonthWeekDay: null,
      selectedRow: null,
      rowSpanInfo: null,
      // mrp pivot
      dateArrayMrp: null,
      mrpInfoList: null,
      mrpTitle: null,
      pivotHeight: 0,
      productypeLookup: null,
      showMrpBtn: null,
      bomTypeValue: 0,
      bomType: ConstDef.BOM_TYPE,
      batchUpload: false, // 차종계획엑셀업로드
      focusedRowKey: 'SG2ALLSG2'
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxSummary,
    DxKeyboardNavigation,
    DxScrolling,
    DxGrouping,
    DxGroupItem,
    MonthPlanComponent,
    DxPopup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }

    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ year: i })
    }
    this.yearArray.unshift({ year: this.thisYear + 1 })
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ name: i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ name: i + '월', value: '' + i })
      }
    }

    // let today = AppLib.getToday()
    // if (today.substring(8, 10) >= '20') {
    //   today = AppLib.calcDateFromToday(12)
    //   this.thisYear = parseInt(today.substring(0, 4))
    //   this.thisMonth = today.substring(5, 7)
    // }
    this.productypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.품목유형
    )
    this.monthDay = AppLib.getMonthLastDay(this.thisYear, this.thisMonth)
  },
  mounted () {
    this.refreshMonthPlan(`${this.thisYear}-${this.thisMonth}-01`)
    this.$refs.refMonthPlan.refreshMonthPlan(
      `${this.thisYear}-${this.thisMonth}-01`
    )
  },
  updated () {},
  beforeDestroy: function () {},
  methods: {
    initDateArray (month, plan) {
      this.dateArray = []
      this.thisMonthWeekDay = 0
      let temp = null
      for (let i = 0; i < this.monthDay; i++) {
        let day = i < 9 ? '0' + (i + 1) : '' + (i + 1)
        temp = {
          caption: `${i + 1}`,
          dataField: `${i + 1}`,
          format: '#,##0',
          dataType: 'number',
          week: AppLib.getWeekNameFromTimestamp(
            AppLib.getTimestampFromString(
              `${this.thisYear}-${this.thisMonth}-${day} 00:00:00`
            )
          )
        }
        if (temp.week !== '토' && temp.week !== '일') {
          this.thisMonthWeekDay++
        }
        this.dateArray.push(temp)
      }
      if (this.updateMode === false) {
        this.initData(month, plan)
      }
    },
    initData (month, plan) {
      // console.log(plan)
      for (let i = 0; i < plan.length; i++) {
        let item = {
          seqId: plan[i].seqId,
          제조사: plan[i].제조사,
          차종: plan[i].차종,
          사양: plan[i].사양,
          상위사양: plan[i].상위사양,
          월계획: null,
          점유율: plan[i].점유율
        }
        for (let j = 0; j < this.monthDay; j++) {
          item[`${j + 1}`] = null
        }
        console.log(item)
        this.planInfoListCar.push(item)
      }
      // console.log(this.planInfoListCar)
      return true // 작업일보 refresh
    },
    onCellPreparedPlan (e) {},
    async onRowUpdatedPlan (row) {
      // console.log(row.data)
      if (row.data.월계획 === null) return
      if (!this.batchUpload) {
        const where = this.$_.where(this.planInfoListCar, {
          차종: row.data.차종
        })
        where.forEach(item => {
          if (
            row.data.점유율 === 1 &&
            item.사양 !== row.data.사양 &&
            item.점유율 !== 1
          ) {
            item.월계획 = Math.ceil(row.data.월계획 * item.점유율)
            const tempAvg = Math.ceil(item.월계획 / this.thisMonthWeekDay)
            let tempSum = 0
            for (let i = 0; i < this.dateArray.length; i++) {
              if (
                this.dateArray[i].week !== '토' &&
                this.dateArray[i].week !== '일'
              ) {
                if (item.월계획 - tempSum >= tempAvg) {
                  item[`${i + 1}`] = tempAvg
                } else {
                  if (item.월계획 - tempSum > 0) {
                    item[`${i + 1}`] = item.월계획 - tempSum
                  } else {
                    item[`${i + 1}`] = null
                  }
                }
                tempSum += tempAvg
              }
            }
            // console.log(item)
          }
        })
      }
      let avg = Math.ceil(row.data.월계획 / this.thisMonthWeekDay)
      let sum = 0
      for (let i = 0; i < this.dateArray.length; i++) {
        if (
          this.dateArray[i].week !== '토' &&
          this.dateArray[i].week !== '일'
        ) {
          if (row.data.월계획 - sum >= avg) {
            row.data[`${i + 1}`] = avg
          } else {
            if (row.data.월계획 - sum > 0) {
              row.data[`${i + 1}`] = row.data.월계획 - sum
            } else {
              row.data[`${i + 1}`] = null
            }
          }
          sum += avg
        }
      }
      this.$refs.refCarPlanGrid.instance.refresh()
    },
    onRowUpdatingPlan (row) {
      if (row.newData.점유율 !== undefined) {
        console.log(row.oldData.사양)
        if (row.oldData.사양 === 'ALL') {
          row.cancel = true
          this.$snotify.info('ALL 사양 점유율은 변경할 수 없습니다.')
        } else if (row.newData.점유율 > 1) {
          row.cancel = true
          this.$snotify.info('점유율은 1.0을 초과할 수 없습니다.')
          row.cancel = true
        } else {
          // 점유율 업데이트
          const param = [
            {
              상위품번: row.oldData.차종,
              품번: row.oldData.사양,
              점유율: row.newData.점유율,
              기준일: `${this.thisYear}-${this.thisMonth}-01`
            }
          ]
          setTimeout(() => {
            this.$_sp
              .runUpdateProc('spUpdateOptionRateByKeyAndDate', param)
              .then(data => {})
          }, 500)
        }
      }
    },
    async onSavePlan () {
      let saveInfo = this.$Q.extend(true, [], this.planInfoListCar)
      const planMonth = `${this.thisYear}-${this.thisMonth}-01`
      const today = AppLib.getToday()
      if (planMonth < today) {
        // this.$snotify.info('전월 및 현재월 계획은 수정 할 수 없습니다.')
        // return
      }
      for (let i = 0; i < this.planInfoListCar.length; i++) {
        saveInfo[i].생산계획 = JSON.stringify(this.planInfoListCar[i])
        saveInfo[i].계획연월 = planMonth
        saveInfo[i].createid = saveInfo[i].updateid = this.userInfo.userName
        if (this.updateMode) {
          saveInfo[i].updateid = this.userInfo.userName
          saveInfo[i].updatetime = AppLib.getNow()
        }
      }
      this.isLoading = true
      await this.$_sp
        .runDeleteSqlProc('월생산계획차종', [
          { 계획연월: saveInfo[0].계획연월 }
        ])
        .then(data => {})
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      console.log(saveInfo)
      await this.$_sp
        .runUpdateProc('spSaveMonthPlanCar', saveInfo)
        .then(data => {
          this.updateMode = true
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      await HttpService.reqPostBody(
        this.$_sp.makeParamModel({
          계획연월: saveInfo[0].계획연월,
          option: 'month'
        }),
        '/saveProductMonthPlan'
      )
        .then(data => {})
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      await HttpService.reqPostBody(
        this.$_sp.makeParamModel({ 계획연월: saveInfo[0].계획연월 }),
        '/saveProductWeekPlan'
      )
        .then(data => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.$refs.refMonthPlan.refreshMonthPlan(
        `${this.thisYear}-${this.thisMonth}-01`
      )
      this.isLoading = false
    },
    onSelectionChanged (e) {
      // console.log(e.row.data)
      console.log(
        this.$refs.refCarPlanGrid.instance.getRowIndexByKey(e.row.data.seqId)
      )
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 66,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: args => {
              this.thisYear = args.value
              this.monthDay = AppLib.getMonthLastDay(
                this.thisYear,
                this.thisMonth
              )
              this.refreshMonthPlan(`${this.thisYear}-${this.thisMonth}-01`)
              this.$refs.refMonthPlan.refreshMonthPlan(
                `${this.thisYear}-${this.thisMonth}-01`
              )
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 60,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: args => {
              this.thisMonth = args.value
              this.monthDay = AppLib.getMonthLastDay(
                this.thisYear,
                this.thisMonth
              )
              this.refreshMonthPlan(`${this.thisYear}-${this.thisMonth}-01`)
              this.$refs.refMonthPlan.refreshMonthPlan(
                `${this.thisYear}-${this.thisMonth}-01`
              )
            }
          }
        },
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            hint: '차종별 월계획 저장',
            icon: 'save',
            text: '차종 월 계획저장',
            type: 'danger',
            focusStateEnabled: false,
            onClick: args => {
              this.onSavePlan()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '월 계획 일괄 등록',
            icon: 'save',
            text: '월 계획 일괄 등록',
            type: 'default',
            focusStateEnabled: false,
            onClick: args => {
              // this.onSavePlan();
              this.$Q('#batch-month-plan-input').click()
            }
          }
        }
      )
    },
    refreshMonthPlan (month) {
      // console.log(month)
      this.isLoading = true
      this.planInfoListCar = []
      this.selectedMonth = `${month.substring(0, 7)}월 완성차_생산계획`
      this.hideMrpList()
      const plan = this.$_sp.runNoEncodeFindProc(
        'spFindAllMonthPlanCarByProduct',
        { 계획연월: month }
      )
      const rowSpan = this.$_sp.runNoEncodeFindProc(
        'spFindAllRowSpanMonthPlanCarBbyCar',
        null
      )
      axios
        .all([plan, rowSpan])
        .then(
          axios.spread((...reponse) => {
            this.rowSpanInfo = this.$_sp.MakeModel(reponse[1])
            // console.log(this.rowSpanInfo)
            let temp = this.$_sp.MakeModel(reponse[0])
            // console.log(temp)
            this.gridHeight = (screen.height - 250) * 0.95
            this.isLoading = false
            this.updateMode = false
            for (let j = 0; j < temp.length; j++) {
              if (temp[j].생산계획 !== null) {
                this.updateMode = true
              }
            }
            if (this.updateMode === false) {
              this.initDateArray(month, temp)
            } else {
              this.initDateArray(month, temp)
              for (let i = 0; i < temp.length; i++) {
                if (temp[i].생산계획 !== null) {
                  this.planInfoListCar.push(JSON.parse(temp[i].생산계획))
                } else {
                  // console.log(temp[i])
                  let item = {}
                  for (let j = 0; j < this.monthDay; j++) {
                    item[`${j + 1}`] = null
                  }
                  temp[i].생산계획 = item
                  this.planInfoListCar.push(temp[i])
                  this.updateMode = true
                }
              }
            }
            console.log(this.planInfoListCar)
          })
        )
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    //* ***************** MRP Pivot *************************** */
    showMrpList () {
      if (this.showMrpBtn !== null) {
        this.showMrpBtn.option({ text: '소요량닫기' })
      }
      this.pivotHeight = this.gridHeight * 0.8
      this.gridHeight -= this.pivotHeight
      this.$Q('.mrp-wrap').show()
    },
    hideMrpList () {
      if (this.showMrpBtn !== null) {
        this.showMrpBtn.option({ text: '소요량보기' })
      }
      this.$Q('.mrp-wrap').hide()
      this.gridHeight = (screen.height - 250) * 0.95
    },
    onToolbarPreparingMrp (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 자재 소요량</b></div>`
          }
        },
        {
          location: 'after',
          widget: 'dxSelectBox',
          options: {
            width: 120,
            items: this.bomType,
            valueExpr: '코드',
            displayExpr: '코드명',
            value: this.bomTypeValue,
            onValueChanged: args => {
              this.bomTypeValue = args.value
              this.refreshMrp(
                `${this.thisYear}-${this.thisMonth}-01`,
                `${this.thisYear}-${this.thisMonth}-${this.monthDay}`
              )
            }
          }
        }
      )
    },
    refreshMrp (from, to) {
      this.isLoading = true
      this.hideMrpList()
      this.mrpTitle = `${this.selectedMonth}-MRP`
      let param = {
        title: this.selectedMonth,
        fromDate: from,
        toDate: to
      }
      let distinctProc = null
      let mrpProc = null
      if (this.bomTypeValue === 1) {
        // 다중BOM
        distinctProc = this.$_sp.runNoEncodeFindProc(
          'spFindAllMrpDisPCodeByTitleAndDate',
          param
        )
        mrpProc = this.$_sp.runNoEncodeFindProc(
          'spFindAllMrpByTitleAndDate',
          param
        )
      } else {
        distinctProc = this.$_sp.runNoEncodeFindProc(
          'spFindAllMassMrpDistinct1StNodePCode',
          param
        )
        mrpProc = this.$_sp.runNoEncodeFindProc(
          'spFindAllMrp1StNodeByTitleAndDate',
          param
        )
      }

      axios
        .all([distinctProc, mrpProc])
        .then(
          axios.spread((...reponse) => {
            this.isLoading = false
            let goods = this.$_sp.MakeModel(reponse[0])
            let mrp = this.$_sp.MakeModel(reponse[1])
            if (mrp.length > 0) {
              this.showMrpList()
              this.setInitDataSource(goods, mrp)
            } else {
              if (this.updateMode === true) {
                this.saveMrp()
              }
            }
          })
        )
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setInitDataSource (goods, mrp) {
      this.dateArrayMrp = []
      for (let i = 0; i < this.monthDay; i++) {
        let temp = {
          caption: i < 9 ? `0${i + 1}` : `${i + 1}`,
          dataField: i < 9 ? `0${i + 1}` : `${i + 1}`,
          format: '#,##0',
          dataType: 'number'
        }
        this.dateArrayMrp.push(temp)
      }
      this.mrpInfoList = []
      for (let i = 0; i < goods.length; i++) {
        let where = this.$_.where(mrp, { 품번: goods[i].품번 })
        let sum = 0
        for (let j = 0; j < where.length; j++) {
          let date = AppLib.formatYMD(where[j].소요일자).substring(8, 10)
          goods[i][date] = where[j].소요량
          sum += where[j].소요량
        }
        goods[i].합계 = sum
      }
      this.mrpInfoList = goods
      // console.log(this.mrpInfoList)
    },
    async confirmRegMonthPlanCar ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        this.$Q('#batch-month-plan-input').val('')
        return
      }
      this.isLoading = true
      this.batchUpload = true
      let file = document.getElementById('batch-month-plan-input')['files'][0]
      this.$Q('#batch-month-plan-input').val('')
      let reader = new FileReader()
      let vm = this
      reader.onloadend = function (event) {
        // excel row cell array = 1 base
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(async function (workbook) {
          const worksheet = workbook.worksheets[0]
          let row = null
          let isRowEmptyCount = 0
          for (let i = 5; ; i++) {
            row = worksheet.getRow(i)
            if (
              AppLib.getCellFromExcel(row, 1) === null ||
              AppLib.getCellFromExcel(row, 1).length === 0
            ) {
              isRowEmptyCount++
              if (isRowEmptyCount > 2) {
                console.log('index= ' + i)
                break
              }
              continue
            }
            isRowEmptyCount = 0
            let carType =
              AppLib.getCellFromExcel(row, 1) === 'undefined'
                ? null
                : AppLib.getCellFromExcel(row, 1)
            let carDetailType =
              AppLib.getCellFromExcel(row, 3) === 'undefined'
                ? null
                : AppLib.getCellFromExcel(row, 3)
            let count =
              AppLib.getCellFromExcel(row, 12) === 'undefined'
                ? null
                : AppLib.getCellFromExcel(row, 12)
            if (carType !== null && carDetailType !== null && count !== null) {
              const whereByCarType = vm.$_.where(vm.planInfoListCar, {
                차종: carType.trim(),
                사양: carDetailType
              })
              if (whereByCarType.length > 0) {
                console.log('carType ->' + carType + ' ' + carDetailType + ' ' + count)
                whereByCarType.forEach(async element => {
                  element.월계획 = parseInt(count)
                })
              }
            }
          }
          vm.shareRefesh()
        })
      }
      reader.readAsArrayBuffer(file)
    },
    shareRefesh () {
      const gByCompany = this.$_.groupBy(this.planInfoListCar, function (list) {
        return list.제조사
      })
      for (const key in gByCompany) {
        if (Object.hasOwnProperty.call(gByCompany, key)) {
          const gByCar = this.$_.groupBy(gByCompany[key], function (list) {
            return list.차종
          })
          for (const key in gByCar) {
            if (Object.hasOwnProperty.call(gByCar, key)) {
              const carList = gByCar[key]
              const allShareCount = carList[0].월계획
              carList.forEach(element => {
                if (element.사양 !== 'ALL' && element.월계획 > 0) {
                  element.점유율 = element.월계획 / allShareCount
                }
              })
            }
          }
        }
      }
      this.planInfoListCar.forEach(ele => {
        this.onRowUpdatedPlan({ data: ele })
      })
      this.$refs.refCarPlanGrid.instance.refresh()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
.mrp-wrap {
  margin-top: 10px;
  overflow: hidden;
}
.temp {
  color: rgb(243, 130, 130);
}
</style>
